// extracted by mini-css-extract-plugin
export default {"root":"AddWithdrawModal_root__1cLQw","input-container":"AddWithdrawModal_input-container__YVPfM"};